import '@/src/js/config';
import '@/src/module/es6Polyfill'
import React from 'react';
import ReactDOM from 'react-dom';

import Comm from '@/src/js/comm';
// new Comm();

ReactDOM.render(
  <Comm/>,
  document.getElementById('App')
);

import '@/src/css/jhc.css';
import '@/src/css/header.css';
import '@/src/css/board.css';
import '@/src/css/input.css';
import '@/src/css/modal.css';

import '@/src/css/style.css';
import '@/src/css/style-custom.css';
import '@/src/css/jhc-m.css';
import 'swiper/swiper-bundle.css';

import 'react-datepicker/dist/react-datepicker.min.css';
import '@/src/css/react-datepicker-custom.css';

// import 'react-datepicker/dist/react-datepicker-min.module.css';
